import React from 'react';
import { Link } from 'react-router-dom'
import icon1 from '../../images/icon/tp-work-icon01.svg'
import icon2 from '../../images/icon/tp-work-icon02.svg'
import icon3 from '../../images/icon/tp-work-icon03.svg'
import icon4 from '../../images/icon/tp-work-icon04.svg'
import icon5 from '../../images/icon/tp-work-icon05.svg'
import icon6 from '../../images/icon/tp-work-icon06.svg'
import iIcon from '../../images/icon/eye-icon.svg'
import iIcon2 from '../../images/icon/sms-white-icon01.svg'


const workItems = [
    {
        id: 1,
        icon: icon1,
        title: 'Continuous Tech Growth',
        content: 'Hands-on learning with emerging technologies through our innovation Fridays and sponsored access to top online learning platforms',
    },
    {
        id: 2,
        icon: icon2,
        title: 'Growth Architecture',
        content: 'Personalized 360° development plans with rotation opportunities across our Dev, Cloud, and Digital Experience teams',
    },
    {
        id: 3,
        icon: icon3,
        title: 'Future-Forward Workspaces',
        content: 'Smart offices featuring AR collaboration zones, innovation labs, and wellness pods with ergonomic tech setups',
    },
    {
        id: 4,
        icon: icon4,
        title: 'Ownership & Recognition',
        content: 'Early-stage equity participation and spot bonuses for exceptional contributions to our core product development',
    },
    {
        id: 5,
        icon: icon5,
        title: 'Tech Community Access',
        content: 'Curated attendance at key industry events and quarterly meetups with local tech ecosystem leaders',
    },
    {
        id: 6,
        icon: icon6,
        title: 'Creativity Unleashed',
        content: '20% passion project time with seed funding for hackathon-winning ideas and internal startup incubation',
    },
];

const WorkSection = (props) => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <section className={`work  pb-130 ${props.bg}`}>
            <div className="container">
                <div className="sec-title--two text-center mb-60">
                    <div className="sub-title">
                        <img src={iIcon} alt="culture icon" />
                        Employee Success Ecosystem
                    </div>
                    <h2 className="title">Why Bogin Tech Teams Thrive</h2>
                </div>
                <div className="tp-work-wrapp">
                    <div className="row mt-none-30">
                        {workItems.map((item) => (
                            <div className="col-lg-6 mt-30" key={item.id}>
                                <div className="tp-work-item">
                                    <div className="xb-item--inner ul_li">
                                        <div className="xb-item--icon">
                                            <img src={item.icon} alt={item.title} />
                                        </div>
                                        <div className="xb-item--holder">
                                            <h3 className="xb-item--title">{item.title}</h3>
                                            <p className="xb-item--content">{item.content}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="header-contact text-center mt-60">
                        <Link onClick={ClickHandler} to="/contact" className="thm-btn thm-btn--aso thm-btn--header-black">
                            Let's Talk
                            <img src={iIcon2} alt="careers icon" />
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default WorkSection;
